/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import * as tslib_1 from "tslib";
import { Directive } from '@angular/core';
import { CdkStepper, CdkStepperNext, CdkStepperPrevious } from '@angular/cdk/stepper';
import { MatStepper } from './stepper';
/**
 * Workaround for https://github.com/angular/angular/issues/17849
 */
export var _MatStepperNext = CdkStepperNext;
export var /** @type {?} */ _MatStepperPrevious = CdkStepperPrevious;
/**
 * Button that moves to the next step in a stepper workflow.
 */
var MatStepperNext = (function (_super) {
    tslib_1.__extends(MatStepperNext, _super);
    function MatStepperNext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MatStepperNext.decorators = [
        { type: Directive, args: [{
                    selector: 'button[matStepperNext]',
                    host: { '(click)': '_stepper.next()' },
                    providers: [{ provide: CdkStepper, useExisting: MatStepper }]
                },] },
    ];
    /**
     * @nocollapse
     */
    MatStepperNext.ctorParameters = function () { return []; };
    return MatStepperNext;
}(_MatStepperNext));
export { MatStepperNext };
function MatStepperNext_tsickle_Closure_declarations() {
    /** @type {?} */
    MatStepperNext.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatStepperNext.ctorParameters;
}
/**
 * Button that moves to the previous step in a stepper workflow.
 */
var MatStepperPrevious = (function (_super) {
    tslib_1.__extends(MatStepperPrevious, _super);
    function MatStepperPrevious() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MatStepperPrevious.decorators = [
        { type: Directive, args: [{
                    selector: 'button[matStepperPrevious]',
                    host: { '(click)': '_stepper.previous()' },
                    providers: [{ provide: CdkStepper, useExisting: MatStepper }]
                },] },
    ];
    /**
     * @nocollapse
     */
    MatStepperPrevious.ctorParameters = function () { return []; };
    return MatStepperPrevious;
}(_MatStepperPrevious));
export { MatStepperPrevious };
function MatStepperPrevious_tsickle_Closure_declarations() {
    /** @type {?} */
    MatStepperPrevious.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatStepperPrevious.ctorParameters;
}
//# sourceMappingURL=stepper-button.js.map